<list-grid [data]="products" route="/product" image="" identifier="ref" elem_by_row="4" perPage="8"></list-grid>